import { SvgIcon, type SvgIconProps } from "@mui/material";
import { type FC, type PropsWithChildren } from "react";

const User: FC<PropsWithChildren<SvgIconProps>> = (props) => (
    <SvgIcon {...props} viewBox="0 0 16 16">
        <path
            fill="#4F9A7A"
            fillRule="evenodd"
            d="M9.625,1 C10.3397214,1 10.927078,1.55522888 10.9937056,2.26517066 L11,2.4 L11,5.182 L7.55935923,8.5 L11,11.818 L11,13.6 C11,14.3277164 10.4546859,14.9257521 9.75742168,14.9935912 L9.625,15 L1.375,15 C0.660278559,15 0.072922045,14.4447711 0.00629436322,13.7348293 L0,13.6 L0,5.2 L4.125,1 L9.625,1 Z M11.5925926,6 L12.3288889,6.705 L10.9859259,8 L16,8 L16,9 L10.9859259,9 L12.3288889,10.29 L11.5925926,11 L9,8.5 L11.5925926,6 Z M9.625,2.4 L8.25,2.4 L8.25,5.2 L9.625,5.2 L9.625,2.4 Z M7.5625,2.4 L6.1875,2.4 L6.1875,5.2 L7.5625,5.2 L7.5625,2.4 Z M5.5,2.4 L4.125,2.4 L4.125,5.2 L5.5,5.2 L5.5,2.4 Z"
        />
    </SvgIcon>
);

export default User;
